// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2dXXT","placeholdersHeader":"styles_placeholdersHeader__2w5dj","editorStyle":"styles_editorStyle__nsndz","placeholdersBox":"styles_placeholdersBox__3-ofN"};